import View404 from './404';
export default View404;
